export default {
  title: 'タイトル',
  organization: '組織',
  website_url: 'ウェブサイトURL',
  description: '説明',
  start_date: '開始年月日',
  end_date: '終了年月日',
};
